import { z, ZodError } from 'zod';

const RecordSchema = z.object({
  email: z.string(),
  from: z.string().optional(),
  timestamp: z.string().datetime({ offset: true }),
});

type SignupRecord = z.infer<typeof RecordSchema>;
type SignupRecordInput = Omit<SignupRecord, 'timestamp'>;

const KEY = '#dpass_signup_record';

const storage: Pick<Storage, 'getItem' | 'setItem'> = (() => {
  try {
    const TEST_KEY = '__TEST__';
    window.localStorage.setItem(TEST_KEY, '');
    window.localStorage.removeItem(TEST_KEY);
    return window.localStorage;
  } catch {
    const memoryStorage: Record<string, string | null> = {};
    return {
      getItem: (key) => memoryStorage[key] ?? null,
      setItem: (key, value) => {
        memoryStorage[key] = value;
      },
      removeItem: (key) => {
        delete memoryStorage[key];
      },
    };
  }
})();

const getDpassSignupRecord = (): SignupRecord | null => {
  try {
    const text = storage.getItem(KEY);
    if (!text) return null;
    return RecordSchema.parse(JSON.parse(text));
  } catch {
    return null;
  }
};

const setDpassSignupRecord = (data: SignupRecordInput) => {
  try {
    const record = RecordSchema.parse({
      ...data,
      timestamp: new Date().toISOString(),
    });
    storage.setItem(KEY, JSON.stringify(record));
  } catch (err) {
    if (err instanceof ZodError) {
      console.error(err.message, data);
    } else if (err instanceof Error) {
      console.warn(err.message);
    }
  }
};

export { getDpassSignupRecord, setDpassSignupRecord };
